import { render } from "./sponsors.vue?vue&type=template&id=cd3db94a&scoped=true"
import script from "./sponsors.vue?vue&type=script&lang=js"
export * from "./sponsors.vue?vue&type=script&lang=js"

import "./sponsors.vue?vue&type=style&index=0&id=cd3db94a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cd3db94a"

export default script